// Import league logos
import ligue1 from "../assets/league/Ligue_1.png";
import can from "../assets/league/caf.png";
import ufc from "../assets/league/UFC.png";
import rsl from "../assets/league/rsl.png";
import bundesliga from "../assets/league/Bundesliga.png";
import mls from "../assets/league/MLS.png";
import ligaportugal from "../assets/league/Primeira_Liga.png";
import seriaA from "../assets/league/Serie_A.png";
import premierLeague from "../assets/league/Premier_League.png";
import f1 from "../assets/league/F1.png";
import fifaWorldCup from "../assets/league/2026_FIFA_World_Cup.png";
import europaLeague from "../assets/league/UEFA_Europa_League.png";
import champions from "../assets/league/Logo_Champions_League.png";
import laliga from "../assets/league/LaLiga.png";
import copaDelRey from "../assets/league/Copa_Del_Rey.png";
import dazn from "../assets/league/DAZN.png";
import motoGp from "../assets/league/Moto_Gp.png";
import supercopa from "../assets/league/Supercopa.png";


export default function Sports() {

    const leagueLogos = [
        { name: "La Liga", src: laliga },
        { name: "Copa Del Rey", src: copaDelRey },
        { name: "Supercopa", src: supercopa },
        { name: "Champions League", src: champions },
        { name: "FIFA World Cup", src: fifaWorldCup },
        { name: "Premier League", src: premierLeague },
        { name: "Europa League", src: europaLeague },
        { name: "Serie A", src: seriaA },
        { name: "DAZN", src: dazn },
        { name: "Bundesliga", src: bundesliga },
        { name: "CAN", src: can },
        { name: "Ligue 1", src: ligue1 },
        { name: "Liga Portugal", src: ligaportugal },
        { name: "RSL", src: rsl },  
        { name: "MLS", src: mls },
        { name: "Formula 1", src: f1 },
        { name: "Moto GP", src: motoGp },
        { name: "UFC", src: ufc },
        
        
        
      ];

    return (
        <section className="pb-10">
            <div className="container m-auto">
                <div className="mb-12 sm:mb-16">
                    <h1 className="text-2xl md:text-3xl max-w-3xl m-auto text-center font-bold text-white">
                        Toutes les chaînes sportives et compétitions en direct
                    </h1>
                </div>
                {(() => {
                    function importAll(requireContext) {
                        return requireContext.keys().map((key) => ({ key, src: requireContext(key) }));
                    }

                    const sportsContext = require.context('../assets/sports', false, /\.(webp|png|jpe?g|svg)$/);
                    const sportsImages = importAll(sportsContext)
                        .sort((a, b) => a.key.localeCompare(b.key))
                        .map((x) => x.src);
                    const sportsLoop = [...sportsImages, ...sportsImages];

                    return (
                        <>
                            <div className="sports-carousel">
                                <div className="sports-marquee">
                                    <div className="sports-track">
                                        {sportsLoop.map((src, index) => (
                                            <div className="sports-item" key={`sport-${index}`}><img src={src} alt={`Sport ${index + 1}`} /></div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="mb-12 sm:mb-16 mt-6 sm:mt-8">
                                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                                    {leagueLogos.map((logo, index) => (
                                        <div
                                        key={index}
                                        className="group bg-white backdrop-blur-md rounded-lg p-6 animate-slide-in-top"
                                        >
                                        <div className="flex items-center justify-center h-8">
                                            <img
                                            src={logo.src}
                                            alt={logo.name}
                                            className="max-h-14 max-w-full object-contain filter group-hover:brightness-110 group-hover:scale-125 transition-all duration-300"
                                            loading="lazy"
                                            />
                                        </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    );
                })()}
            </div>
        </section>
    );
}
